import React, { FC } from "react";
import { noop } from "lodash";
import { TemplateId } from "src/globalTypes";
import useFilesAndItsActions from "./hooks/useFilesAndItsActions";
import { FlowioFile, TableRow } from "../../../requests/table/types";
import FileListWithInput from "./components/FileListWithInput";
import { getFilesCount } from "./utils";

const Container: FC<Props> = ({
  templateId,
  fileValue,
  templateItemId,
  hegSubjectNumberColumnName,
  disabled = true,
  disabledButton,
  afterFileUploadCallback = noop,
  row,
}) => {
  const { recordId, filesCount } = fileValue;

  const {
    files,
    areFilesLoading,
    openFile,
    uploadFiles,
    downloadFile,
    deleteFile,
    fetchFilesOnOpen,
  } = useFilesAndItsActions({
    templateId,
    templateItemId,
    row,
    afterFileUploadCallback,
    hegSubjectNumberColumnName,
    recordId: recordId || row?.keyValue || null,
    editMode: !disabled,
  });

  return (
    <FileListWithInput
      files={files}
      filesCount={getFilesCount(filesCount, files, !disabled)}
      areFilesLoading={areFilesLoading}
      disabled={disabled}
      disabledButton={disabledButton}
      fetchFilesOnOpen={fetchFilesOnOpen}
      openFile={openFile}
      downloadFile={downloadFile}
      uploadFiles={uploadFiles}
      deleteFile={deleteFile}
    />
  );
};

export type Props = {
  fileValue: FlowioFile;
  templateId: TemplateId;
  templateItemId: number | string;
  hegSubjectNumberColumnName?: string | null;
  disabled?: boolean;
  disabledButton?: boolean;
  afterFileUploadCallback?: () => void;
  row?: TableRow;
};

export default Container;
